/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Button to add new payer from eligibility form
 */
import { App, Button } from 'antd';
import { Plus } from '@icon-park/react';
import { useNavigate } from 'react-router-dom';

import { MODAL_TYPES } from '../modal';
import { getManagePayersPath } from 'utils/router';

const AddPayerModal: React.FC = () => {
	const { modal } = App.useApp();
	const navigate = useNavigate();

	const handleClick = () => {
		modal.confirm({
			...MODAL_TYPES.confirm,
			title: 'Add a New Payer',
			content:
				"You'll be taken to the payers section in settings to add a new payer. Once added, the payer will be available in this dropdown.",
			okText: 'Proceed',
			cancelText: 'Cancel',
			onOk: () => navigate(getManagePayersPath(), { state: { fromEligibility: true } }),
		});
	};

	return (
		<Button type='default' icon={<Plus />} onClick={handleClick}>
			{'Add New Payer'}
		</Button>
	);
};

export default AddPayerModal;
